<template>
	<div id="myAccount" class="row">
		<!-- <div class="container"> -->
		<div class="sidebar col-12 col-md-3">
			<div class="sidebarInner">
				<ul>
				<li class="sidebarItem">
					<router-link :to="{name:'account'}">My Details</router-link>
				</li>
				<li class="sidebarItem">
					<router-link :to="{name:'accountPreferences'}">My Preferences</router-link>
				</li>
				<li class="sidebarItem">
					<router-link :to="{name:'accountChangePassword'}">Change Password</router-link>
				</li>
				<li class="sidebarItem">
					<router-link :to="{name:'accountPurchases'}">My Purchases</router-link>
				</li>
				<li v-if="membersOnAccount < accountCountLimit" class="sidebarItem">
					<router-link :to="{name:'accountMembership'}">Add Member</router-link>
				</li>
				<li class="sidebarItem">
					<router-link :to="{name:'accountReferrals'}">Refer a Friend</router-link>
				</li>
				<li v-if="memberLevel == 'silver'" class="sidebarItem gold">
					<router-link :to="{name:'accountPoints'}">My Points</router-link>
				</li>
				<li class="sidebarItem">
					<router-link :to="{name:'accountFavourites'}">My Favourites</router-link>
				</li>
				<li v-if="needsUpgrade" class="sidebarItem gold">
					<router-link :to="{name:'accountGoldUpgrade'}">Gold Upgrade</router-link>
				</li>
				<li v-if="memberLevel == 'silver' || memberLevel == 'gold'" class="sidebarItem platinum">
					<router-link :to="{name:'accountPlatinumUpgrade'}">Platinum Upgrade</router-link>
				</li>
				<li v-if="!needsUpgrade" class="sidebarItem gold">
					<router-link :to="{name:'accountMembershipRenewal'}">Renew Membership</router-link>
				</li>
				</ul>
			</div>
		</div>
		<div class="content col-12 col-md-9">
			<!-- Shows My account content -->
			<transition name="fade">
				<router-view/>
			</transition>
		</div>
		<vue-headful title="My Account | Cherrytree"/>
	</div>
</template>

<script>
import {mapState} from 'vuex'
export default {
	name: "MyAccount",
	computed:{
		...mapState({
			membersOnAccount: state => state.auth.account_count,
			memberLevel: state => state.auth.memberLevel,
			canTransact: state => state.member.canTransact,
		}),
		accountCountLimit(){
			return 2
		},
		needsUpgrade() { 
			return this.memberLevel == "silver" || (this.memberLevel == "gold" && !this.canTransact);
		}
	}
};
</script>

<style lang="scss" scoped>
// sidebar styles are set in the sidebar.scss file in styles folder
@include media-breakpoint-down(sm) {
  #sidebar{
    ul{
      justify-content: space-around;
      display: flex;
      flex-wrap: wrap;
    }
    .sidebarItem{
      display:inline-block;
      margin:5px 0;
      padding:5px;
      border: 1px solid #ddd;
      width:48%;
    }
  }
}

@include media-breakpoint-up(md){

  ul{
    display:block;
  }
}

.content {
  padding:20px;
}

.gold{
  background: $CTgold;
}

.platinum {
	background: $CTPlatinum;
	a, a:hover,{
		color: #fff !important;

	}
	
}
</style>
